import { Button } from "@/components/ui/button";
import type { Contact } from "@/types/booking-history/bookinghistorydetail";
import { useNavigate } from "react-router-dom";

type ContactDetailsCardProps = {
  contact: Contact;
  paymentId?: string;
};

export function ContactDetailsCard({ contact, paymentId }: ContactDetailsCardProps) {
  const navigate = useNavigate();

  const handleEditContactDetails = () => {
    //navigate(`/booking-history/`);
       navigate(`/booking-history/${paymentId}/contact`, {
         state: { contact },
       });
  };

  return (
    <>
      <h2 className="mt-8 text-lg font-semibold text-secondary-foreground">
        Contact Details
      </h2>
      <section className="rounded-2xl mt-2 p-4 bg-card shadow-xl">
        <div className="flex flex-col justify-between gap-4 md:grid md:grid-cols-3 md:items-center">
          <div>
            <p className="text-muted text-xs font-medium leading-tight md:text-sm">
              Contact Name
            </p>
            <p className="text-sm text-muted-foreground font-medium mt-1 md:text-base">
              {contact.name}
            </p>
          </div>

          <div className="mt-4 flex justify-between gap-4 md:mt-0">
            <div>
              <p className="text-muted text-xs font-medium leading-tight md:text-sm">
                Email Address
              </p>
              <p className="text-sm text-muted-foreground font-medium mt-1 md:text-base">
                {contact.email}
              </p>
            </div>
            <div>
              <p className="text-muted text-xs font-medium leading-tight md:text-sm text-end md:text-start">
                Contact No.
              </p>
              <p className="text-sm text-muted-foreground font-medium mt-1 md:text-base text-end md:text-start">
                {contact.mobileNoCountryCode}{contact.mobileNo} 
              </p>
            </div>
          </div>
          <div className="md:flex md:justify-end">
            <Button
              type="button"
              variant="default"
              className="mt-4 w-full cursor-pointer bg-muted-foreground hover:bg-[#242424] md:w-2xs md:mt-0"
              onClick={handleEditContactDetails}
            >
              Edit Contact Details
            </Button>
          </div>
        </div>
      </section>
    </>
  );
}
